import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import * as advertEndpoint from "modules/Advert/_redux/advertEndpoint";
import { generateCategoryDetail } from "helpers";
import { getCategoryVisual } from "helpers/categoryVisual";
import AdvertCard from "./AdvertCard";
import SectionHead from "./SectionHead";
import "./AutoScrollShowcase.css";

// Bir satırı sonsuz döngü hissi için en az bu kadar karta tamamlar; az ilanlı
// kategorilerde içerik tekrar edilerek şerit boş kalmadan akar.
const MIN_PER_ROW = 6;
// Bir satırın baştan sona akış süresi kart başına ~5sn; uzun satır = yavaş akış.
const SECONDS_PER_CARD = 5;

// Diziyi hedef uzunluğa ulaşana dek kendisiyle tekrar eder.
function padToMin(items) {
  if (items.length >= MIN_PER_ROW) return items;
  const out = [];
  while (out.length < MIN_PER_ROW) out.push(...items);
  return out;
}

function AutoScrollShowcase() {
  const [adverts, setAdverts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    advertEndpoint
      .getAdvertsWithPaginate(1, 120, "desc")
      .then((res) => res.data)
      .then((data) => {
        if (!active) return;
        setAdverts(data?.results || []);
        setLoaded(true);
      })
      .catch(() => {
        if (!active) return;
        setAdverts([]);
        setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  // Kategoriye göre grupla; en çok ilanlı kategori üstte.
  const groups = useMemo(() => {
    const map = new Map();
    adverts.forEach((a) => {
      const cat = a.category;
      if (!cat || !cat.slug) return;
      const key = cat._id || cat.slug;
      if (!map.has(key)) map.set(key, { key, category: cat, items: [] });
      map.get(key).items.push(a);
    });
    return Array.from(map.values())
      .filter((g) => g.items.length >= 3)
      .sort((x, y) => y.items.length - x.items.length);
  }, [adverts]);

  if (!loaded || groups.length === 0) return null;

  return (
    <div className="hs-section container">
      <SectionHead
        title="Kategoriden Kategoriye"
        subtitle="İlanlar kendiliğinden akıyor — durdurmak için üzerine gelin"
        accent="#0F1B17"
      />
      <div className="ass">
        {groups.map((g, gi) => {
          const { Icon, color, image } = getCategoryVisual(g.category);
          const filled = padToMin(g.items);
          // İçeriği 2x kopyalayıp -%50 ötelediğimiz için döngü kusursuz birleşir.
          const loop = [...filled, ...filled];
          const duration = Math.max(filled.length * SECONDS_PER_CARD, 24);
          const reverse = gi % 2 === 1;
          return (
            <div className="ass-cat" key={g.key}>
              <div className="ass-cat__head">
                <Link
                  to={generateCategoryDetail(g.category.slug)}
                  className="ass-cat__pill"
                  style={{ "--cat-color": color }}
                >
                  <span
                    className={`ass-cat__pill-ico${
                      image ? " ass-cat__pill-ico--photo" : ""
                    }`}
                  >
                    {image ? (
                      <img
                        src={image}
                        alt={g.category.name}
                        className="ass-cat__pill-img"
                      />
                    ) : (
                      <Icon size={19} color={color} />
                    )}
                  </span>
                  {g.category.name}
                </Link>
                <span className="ass-cat__more">{g.items.length} güncel ilan</span>
              </div>
              <div className="ass-row">
                <div
                  className={`ass-track${reverse ? " ass-track--right" : ""}`}
                  style={{ "--ass-duration": `${duration}s` }}
                >
                  {loop.map((item, idx) => (
                    <AdvertCard
                      advert={item}
                      key={`${item.id || item._id}-${idx}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AutoScrollShowcase;
